module.exports = __webpack_public_path__ + "static/media/industries.fd473ead.png";